/**
 * Permission Service - API methods for permission management
 */

import apiClient from './apiClient';

// Permission type
export interface Permission {
  id: string;
  key: string;
  resource: string;
  action: string;
  displayName: string;
  description?: string;
  /** Feature-module this permission belongs to; null = not license-gated. Always present. */
  module: string | null;
}

// Permissions grouped by resource
export interface PermissionsGroupedByResource {
  [resource: string]: Permission[];
}

/**
 * Get all permissions grouped by resource
 */
export const getAllPermissions = async (): Promise<PermissionsGroupedByResource> => {
  const response = await apiClient.get<PermissionsGroupedByResource>('/api/v1/permissions');
  return response.data;
};

/**
 * Get current user's effective permissions
 */
export const getMyPermissions = async (): Promise<string[]> => {
  const response = await apiClient.get<{ permissions: string[] }>('/api/v1/permissions/my');
  return response.data.permissions;
};

const permissionService = {
  getAllPermissions,
  getMyPermissions,
};

export default permissionService;
